import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiMethod } from '../../../apimethods/api-method';
import { BusinessRuleTypeModel } from './business_rule-TypeModel';
import * as ngswal from "sweetalert";
import { customfunctions, DataParam } from '../../../common/customfunctions';
import { GlobalConstants } from '../../../common/global-constants';
import { Router } from '@angular/router';


declare var $;


@Component({
    selector: 'app-business-rule-type',
    templateUrl: './business-rule-type.component.html',
    styleUrls: ['./business-rule-type.component.css']
})
/** BusinessRuleType component*/
export class BusinessRuleTypeComponent implements OnInit {

    modelItem = new BusinessRuleTypeModel();
    dataTable: any; @ViewChild('dataTable', { static: false }) table; dataSet: any;
    popupButtonText: string;
    title: string;


    ngOnInit() {

        ApiMethod.getBaseUrl();
    }

    constructor() {
        ApiMethod.getPageConfig().subscribe(
            data => {
                this.modelItem = <BusinessRuleTypeModel>data["BusinessRuleTypePage"];
                this.GetBusinessRuleType();

            }, error => {
                ngswal("Warning !", error.message, "warning");
            });
    }

    GetBusinessRuleType() {
        $("#LoadingImage").show();

        var BusinessRuleTypeData = {
            LoginId: localStorage.aLoginID,
            PublisherId: localStorage.aPubID
        };

        ApiMethod.postMethod(this.modelItem.BusinessRuleTypeAPI, BusinessRuleTypeData).subscribe(
            result => {
                this.dataSet = JSON.stringify(result.aitemList);
                this.dataSet = JSON.parse(this.dataSet);
                this.dataTable = $(this.table.nativeElement);

                //Dynamic datable
                let acolList = result.acolListL;
                let dataItem = new DataParam();
                dataItem.acolList = acolList;
                dataItem.aNewButtonName = "btn_AddNew";
                dataItem.dataTable = this.dataTable;
                dataItem.dataset = this.dataSet;
                dataItem.dtheight = (GlobalConstants.size.height - 160);
                dataItem.modulename = "BusinessRuleTypeModule";
                dataItem.isDefault = false;
                this.dataTable = customfunctions.dynamicDataTable(dataItem);
                //Dynamic datable

                $("#LoadingImage").hide();


            }, error => {
                $("#LoadingImage").hide();
                ngswal("Failed !", error.message, "error");
            });
    }

    showBusinessRuleType(): void {
        $("#btnPopupartDetails").show();
        this.ClearData();
        if (localStorage.aEID != 0) {
            $("#LoadingImagePopup").show();
            ApiMethod.getMethod(this.modelItem.BusinessRuleTypeByID + '/' + localStorage.aEID).subscribe(
                result => {
                    $("#LoadingImagePopup").hide();
                    let aitems = result.aitemList;
                    console.log(aitems);

                    $('#Txt_RuleType').val(aitems[0].RuleType);
                    $('#Txt_Prefix').val(aitems[0].Prefix);
                    $('#Txt_StartRuleNo').val(aitems[0].StartRuleNo);

                },
                error => {
                    ngswal("Failed !", error.error.Message, "warning");
                }
            );
            this.popupButtonText = "Update";
        } else this.popupButtonText = "Save";
        this.title = "Business Rule Type Details";
    }

    UpdateBusinessRuleType(): void {
        if ($('#Txt_RuleType').val() == '') {
            ngswal("Warning !", "Enter RuleType!", "warning");
        }
        else if ($('#Txt_Prefix').val() == '') {
            ngswal("Warning !", "Enter Prefix!", "warning");
        }
        else if ($('#Txt_StartRuleNo').val() == '') {
            ngswal("Warning !", "Enter Start Rule No!", "warning");
        }

        else {
            $("#LoadingImagePopup").show();         
            var businessRuleTypeData =
            {
                Id: localStorage.aEID,
                RuleType: $('#Txt_RuleType').val(),
                Prefix: $('#Txt_Prefix').val().toUpperCase().toString(),
                StartRuleNo: $('#Txt_StartRuleNo').val(),
                UpdatedBy: localStorage.aLoginID

            };
            console.log(businessRuleTypeData);

            ApiMethod.postMethod(this.modelItem.UpdateBusinessRuleTypeAPI, businessRuleTypeData).subscribe(
                resonse => {

                    $("#LoadingImagePopup").hide();
                    if (resonse.status) {

                        ngswal({
                            position: 'top-end',
                            type: "success",
                            title: "Updated !",
                            text: resonse.message,
                            showConfirmButton: true,

                        });
                        this.GetBusinessRuleType();
                        this.hide();
                    } else {
                        ngswal({
                            position: 'top-end',
                            type: "warning",
                            title: "Failed !",
                            text: resonse.message,
                            showConfirmButton: true,
                        });
                    }

                },
                error => {
                    ngswal("Failed!", error.error.Message, "error");
                    $("#LoadingImagePopup").hide();
                }
            );

        }

    }

    deleteBusinessRuleType() {
        $("#LoadingImagePopup").show();
        ApiMethod.getMethod(this.modelItem.DeleteBusinessRuleTypeID + "/" + localStorage.aEID).subscribe(
            Response => {
                this.hide();
                this.GetBusinessRuleType();
                if (Response.status) {
                    ngswal({
                        position: 'top-end',
                        type: "success",
                        title: "Updated !",
                        text: Response.message,
                        showConfirmButton: true,
                    });
                } else {
                    ngswal({
                        position: 'top-end',
                        type: "warning",
                        title: "Failed !",
                        text: Response.message,
                        showConfirmButton: true,
                    });
                }

                $("#LoadingImagePopup").hide();
            }, error => {
                $("#LoadingImagePopup").hide();
                ngswal("Failed !", error.message, "error");
            }
        );
    }

    Deleteconfirmation() {
        ngswal({
            title: "Are You Confirm to delete Business Rule Type?",
            text: "Business Rule Type deleted Permanently..!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            closeOnConfirm: true,
            closeOnCancel: true
        },
            function (isConfirm) {

                if (isConfirm) {
                    $('#btnDeleteBusinessRule').trigger("click");
                } else {
                    return false;
                }
            });
    };

    ClearData(): void {
        $("input[type='text']").val("");
        $("input[type='number']").val("");
    }

    hide(): void {
        $("#btnPopupartDetails").hide();

    }
}
